module.exports = __webpack_public_path__ + "images/vigor-footer__-905N.png";